import { useDispatch, useSelector } from "react-redux";

import constants from "../store/constants";

import {
  CLEANED_AUTOGIRO,
  CLEANED_FORTNOX,
  CLEANED_PE,
  CLEANED_KIVRA,
  CLEANED_VISMA,
} from "./instructions";

export function usePEForm(method, open) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!open) return;

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_PE,
        name: "integration_pe",
        method: method,
      },
    });
  }

  return hasForm;
}

export function useAutogiroForm(method, open) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!open) return;

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_AUTOGIRO,
        name: "integration_autogiro",
        method: method,
      },
    });
  }

  return hasForm;
}

export function useFortnoxForm(method, open) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!open) return;

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_FORTNOX,
        name: "integration_fortnox",
        method: method,
      },
    });
  }

  return hasForm;
}

export function useVismaForm(method, open) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!open) return;

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_VISMA,
        name: "integration_visma",
        method: method,
      },
    });
  }

  return hasForm;
}

export function useKivraForm(method, open) {
  const dispatch = useDispatch();

  const hasForm = useSelector((state) =>
    Boolean(state[constants.STORE_NAME].forms[method])
  );

  if (!open) return;

  if (!hasForm) {
    dispatch({
      type: constants.INSERT_INTO_FORMS,
      payload: {
        result: CLEANED_KIVRA,
        name: "integration_kivra",
        method: method,
      },
    });
  }

  return hasForm;
}
